import { Button, Textarea } from 'flowbite-react';
import { useState } from 'react';

export type ReworkModalProps = {
  onConfirm: (comment: string) => void;
  onCancel: () => void;
};

export const ReworkModal = ({ onConfirm, onCancel }: ReworkModalProps) => {
  const [comment, setComment] = useState('');
  return (
    <div className="space-y-6">
      <div>
        <p className="text-sm font-medium text-gray-900 mb-2">
          Требуются изменения
        </p>
        <Textarea
          value={comment}
          onChange={(e) => setComment(e.target.value)}
          placeholder="Объясните клиенту как можно решить возникшую проблему"
          rows={4}
          className="w-full"
        />
      </div>
      <div className="flex gap-4 border-t border-gray-200 pt-4">
        <Button color="primary" onClick={() => onConfirm(comment)}>
          Исправить
        </Button>
        <Button color="light" onClick={onCancel}>
          Отмена
        </Button>
      </div>
    </div>
  );
};
